import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'
import { Link } from 'react-router-dom'

import { sagaGetCalculationProcessStepListingAction } from 'saga/actions/calculationprocessStep'
import { RootState } from 'store'
import { RoutePaths } from 'routes/paths'
import PaperWrapper from 'components/custom/PaperWrapper'
import ContentBodyWrapper from 'components/custom/ContentBodyWrapper'
import ButtonWrapper from 'components/custom/ButtonWrapper'
import SearchBar from 'components/custom/SearchBar'
import { CollapsibleCalculationProcessStepList } from './components/CollapsibleCalculationProcessStepList'
import { componentPermissions } from 'config/permissions'
import { componentNames } from 'config/roles'

const CalculationSteps: FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(sagaGetCalculationProcessStepListingAction())
  }, [dispatch])

  const stepListing = useSelector(
    (state: RootState) =>
      state.calculationProcessStepListing.calculationProcessStepListing?.data ??
      []
  )

  return (
    <ContentBodyWrapper title={t('toolbox.title')}>
      <PaperWrapper>
        <Typography
          variant="h4"
          className="h-full px-4"
          fontSize="1.5rem"
          fontWeight="500"
        >
          {t('toolbox.calculationSteps.title')}
        </Typography>
        <div className="flex flex-wrap gap-y-2 gap-x-3 mt-12 mb-2 mr-5 justify-between">
          <div className="flex-grow">
            <SearchBar
              label={t('general.searchTopicInput', {
                topic: t('toolbox.calculationSteps.title'),
              })}
              placeholderProp={t('general.search')}
              customValue=""
            />
          </div>
          <Link to="/toolbox/assembler">
            <ButtonWrapper>{t('assembler.builder')}</ButtonWrapper>
          </Link>
        </div>

        <CollapsibleCalculationProcessStepList data={stepListing} />
      </PaperWrapper>
    </ContentBodyWrapper>
  )
}

const exportObj = {
  routeProps: {
    path: RoutePaths.toolboxAssemblerCalculationSteps,
    title: 'toolbox.calculationSteps.title',
    element: <CalculationSteps />,
    roles: componentPermissions[componentNames.pageAssembler],
    requiresAuthentication: true,
  },
  name: 'Calculation Steps',
}

export default exportObj
